import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
    DialogTitle,
    DialogContent,
    DialogContentText,
} from '@mui/material';
import { toastr } from 'react-redux-toastr';
import { Table, EmptyTableText } from '../../../common-client2/src/components';
import { loadRuleSet, loadDuplicateRuleSet, deleteRuleSet } from '../store/ruleSet';
import { setColumnWidth } from '../store/appData/appData.reducer';

/**
 * @param {{
 *  data: RuleSet.IRuleSetBrief[]
 *  setShowSidePanel: Function
 * }} props
 */
function RuleSetTable(props) {
    const dispatch = useDispatch();
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'settings.ruleSet' });

    const pendingTasks = useSelector((state) => state.pendingTasks);
    /** @type {AdminAppData.IAppData} */
    const adminAppData = useSelector((/** @type {EmploymentBillboard.AdminStore} */ state) => state.adminAppData);
    const { paycodeList, ruleSetColumnsWidths } = adminAppData;
    const { data, setShowSidePanel } = props;
    const columns = [
        {
          key: 'name',
          tKey: 'columns.name',
          sortable: true,
          width: ruleSetColumnsWidths.name ?? 200,
          resizable: true
        },
        {
          key: 'description',
          tKey: 'columns.description',
          sortable: true,
          width: ruleSetColumnsWidths.description ?? 300,
          resizable: true
        },
        {
          key: 'ruleSetTypeName',
          tKey: 'columns.ruleSetType',
          sortable: true,
          flexGrow: 1
        },
        {
          key: 'requestTypeName',
          tKey: 'columns.requestType',
          sortable: true,
          width: 150,
          flexGrow: 1
        },
        {
          key: 'requestSubtypeName',
          tKey: 'columns.requestSubtype',
          sortable: true,
          width: 170,
          flexGrow: 1
        },
        {
          key: 'activeLabel',
          tKey: 'columns.isActive',
          sortable: true,
          width: 160,
          flexGrow: 1
        }
      ];
    /**
     * @param {RuleSet.IRuleSetDetails} rowData
     */
    const handleEdit = (rowData) => {
        dispatch(loadRuleSet(rowData.ruleSetId, paycodeList))
        setShowSidePanel(true)
    };

    /**
     * @param {RuleSet.IRuleSetDetails} rowData
     */
    const handleDuplicate = (rowData) => {
        const allRuleSetNames = data.map(x => x.name);
        dispatch(loadDuplicateRuleSet(rowData.ruleSetId, paycodeList, allRuleSetNames, t('copyOf')))
        setShowSidePanel(true);
    };

    /**
     * @param {RuleSet.IRuleSetDetails} rowData
     */
    const handleDelete = (rowData) => {
        const toastrConfirmOptions = {
            onOk: () => {
                dispatch(deleteRuleSet(rowData.ruleSetId, rowData.ruleSetType));
            },
            onCancel: () => { },
            component: () => (
                <div >
                    <DialogTitle style={{ padding: '16px 24px' }}>
                        {t('delete')}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {t('deleteConfirmation', { name: rowData.name })}
                        </DialogContentText>
                    </DialogContent>
                </div>
            ),
        };
        toastr.confirm('', toastrConfirmOptions);
    };

    return (
        <Table
            loading={!!pendingTasks}
            data={data}
            columns={columns}
            id="rulesets-table"
            renderEmpty={() => <EmptyTableText text={t('noRuleSetFound')} />}
            onEdit={(_, value) => handleEdit(value)}
            onDuplicate={(_, value) => handleDuplicate(value)}
            onDelete={(_, value) => handleDelete(value)}
            onColumnResize={(key, width) => dispatch(setColumnWidth(key, width))}
            fillAvailableHeight
            rowHeight={40}
            defaultSortColumnKey="name"
            disableSearch
        />
    );
}
export default RuleSetTable;
